import { SegmentService } from '../../services/Segment.service'
import { Array } from 'core-js';

const state = {
    chartDataApi: Array,
    tableDataApi: Array,
    QuestionList: [],
    chartData: Array,
    tableData: [],
    headerData: [],
    modelQuestionRadios: 'CompositeQuestion',
    currentQuestion: ''
}

// getters
const getters = {
}


function getInputCategoriesForCohort(filterArray, inputCategories) {
    filterArray.map((filter) => {
        inputCategories.push('Cohort-' + filter.userSettingId);
    })
    return inputCategories;
}

function getInputCategories(filterArray, inputCategories) {
    filterArray.map((filter) => {
        inputCategories = inputCategories.concat(
            filter.keyValues.map((keyval) => {
                return keyval.itemValue;
            })
        );
    })
    return inputCategories;
}

// actions
const actions = {
    updateChart({ commit }, scoreView) {
        commit('setChartDataAsPerScoreView', { scoreView: scoreView });
    },
    updateChartByQuestion({ commit, rootState }, QuestionNo) {
        commit('setChartDataAsPerQuestion', { QuestionNo: QuestionNo, scoreView: rootState.YourDataStore.modelScoreRadios });
    },

    GetClientDataWithCohort({ commit, rootState }) {

        //console.log(rootState.UserSettingStore.tblCohortListFilters);

        let yourDataFilters = rootState.CategoriesStore.tblYourDataFilters;
        let benchmarkFilters = rootState.CategoriesStore.tblBenchmarkFilters;
        let cohortMeasureFilters = rootState.CategoriesStore.tblCohortFilters;
        let cohortListFilters = rootState.UserSettingStore.tblCohortListFilters;

        //console.log(cohortListFilters)

        if (cohortMeasureFilters.length == 0) {
            return;
        }

        let inputCategories = [];
        inputCategories = getInputCategories(yourDataFilters, inputCategories);
        inputCategories = getInputCategories(benchmarkFilters, inputCategories);
        inputCategories = getInputCategories(cohortMeasureFilters, inputCategories);
        inputCategories = getInputCategoriesForCohort(cohortListFilters, inputCategories);

        let clientId = rootState.UserManagementStore.UserClientId;
        inputCategories.push("ClientID-" + clientId);
        const filters = {
            SampleTypeId: rootState.AppStore.ProductLine.payload,
            Filters: {
                SelectedOptions: inputCategories
            }
        }
        //console.log(JSON.stringify(filters));
        return new Promise((resolve, reject) => {
            SegmentService.GetClientDataWithCohort(
                filters,
                apiData => {
                    commit('setChartAndTableData',
                        {
                            apiData: apiData,
                            scoreView: rootState.YourDataStore.modelScoreRadios
                        }),
                        //console.log(JSON.stringify(apiData));
                        resolve()
                },
                err => {
                    reject(err)
                }
            )
        })
    },

    getClientDataWithSegmentation({ commit, rootState }) {
        let yourDataFilters = rootState.CategoriesStore.tblYourDataFilters;
        let benchmarkFilters = rootState.CategoriesStore.tblBenchmarkFilters;
        let segmentFilters = rootState.CategoriesStore.tblSegmentFilters;

        if (segmentFilters.length == 0) {
            return;
        }

        let inputCategories = [];
        inputCategories = getInputCategories(yourDataFilters, inputCategories);
        inputCategories = getInputCategories(benchmarkFilters, inputCategories);
        inputCategories = getInputCategories(segmentFilters, inputCategories);

        let clientId = rootState.UserManagementStore.UserClientId;
        inputCategories.push("ClientID-" + clientId);
        const filters = {
            SampleTypeId: rootState.AppStore.ProductLine.payload,
            Filters: {
                SelectedOptions: inputCategories
            }
        }

        //console.log(JSON.stringify(filters));
        return new Promise((resolve, reject) => {
            SegmentService.getClientDataWithSegmentation(
                filters,
                apiData => {
                    commit('setChartAndTableData',
                        {
                            apiData: apiData,
                            scoreView: rootState.YourDataStore.modelScoreRadios
                        }),
                        resolve()
                },
                err => {
                    reject(err)
                }
            )
        })
    },


    getCompositeQuestionTextForCohort({ commit, rootState }) {
        let compAbbr = '';
        if (rootState.CategoriesStore.tblCohortFilters.length == 0) return;

        let inputCategories = [];
        inputCategories = getInputCategories(rootState.CategoriesStore.tblCohortFilters, inputCategories);

        for (let i = 0; i < inputCategories.length; i++) {
            if (inputCategories[i].startsWith('CompAbbrev')) {
                compAbbr = inputCategories[i];
                break;
            }
        }

        /*for (let i = 0; i < rootState.CategoriesStore.modelCohortFilters.length; i++) {
            let filterVal = rootState.CategoriesStore.modelCohortFilters[i];
            let catkeval = filterVal.split('|');
            if (catkeval != null && catkeval.length > 0) {
                let categoryName = catkeval[0];
                //let keyvalname = catkeval[1];
                let keyval = catkeval[2];
                if (categoryName == 'Measures') {
                    compAbbr = keyval;
                }
            }
        }*/

        const filters = {
            CompAbbrev: compAbbr,
            ProductType: rootState.AppStore.ProductLine.payload,
            ClientId: rootState.UserManagementStore.UserClientId
        }
        return new Promise((resolve, reject) => {
            SegmentService.getQuestionList(
                filters,
                apiData => {
                    commit('setCompositeQuestionText', { apiData: apiData }),
                        resolve()
                },
                err => {
                    reject(err)
                }
            )
        })
    },

    getCompositeQuestionText({ commit, rootState }) {
        let compAbbr = '';
        if (rootState.CategoriesStore.tblSegmentFilters.length == 0) return;

        let inputCategories = [];
        inputCategories = getInputCategories(rootState.CategoriesStore.tblSegmentFilters, inputCategories);

        for (let i = 0; i < inputCategories.length; i++) {
            if (inputCategories[i].startsWith('CompAbbrev')) {
                compAbbr = inputCategories[i];
                break;
            }
        }

        /*for (let i = 0; i < rootState.CategoriesStore.modelSegmentFilters.length; i++) {
            let filterVal = rootState.CategoriesStore.modelSegmentFilters[i];
            let catkeval = filterVal.split('|');
            if (catkeval != null && catkeval.length > 0) {
                let categoryName = catkeval[0];
                //let keyvalname = catkeval[1];
                let keyval = catkeval[2];
                if (categoryName == 'Measures') {
                    compAbbr = keyval;
                }
            }
        }*/

        const filters = {
            CompAbbrev: compAbbr,
            ProductType: rootState.AppStore.ProductLine.payload,
            ClientId: rootState.UserManagementStore.UserManagementStore
        }
        return new Promise((resolve, reject) => {
            SegmentService.getQuestionList(
                filters,
                apiData => {
                    commit('setCompositeQuestionText', { apiData: apiData }),
                        resolve()
                },
                err => {
                    reject(err)
                }
            )
        })
    },
    resetCompositeQuestionText({ commit }) {
        commit('resetCompositeQuestionText')
    }
}

function getTableHeadersAndChartLabels(lables) {
    let chartCategories = [];
    let tableHeaders = [];
    tableHeaders.push(
        {
            text: "Data Points",
            value: "displayName"
        }
    );
    for (let k = 0; k < lables.length; k++) {
        let label = lables[k];
        tableHeaders.push(
            {
                text: label.value,
                value: label.code
            }
        );
        chartCategories.push(label.value);
    }
    return {
        tableHeaders: tableHeaders,
        chartCategories: chartCategories
    }
}

function getScoreArrayForChart(lables, inputScoreArray) {
    let outputScoreArray = [];
    let innerArray = [];

    inputScoreArray.map((score) => {
        innerArray = [];
        let questionNo = score.questionNo == '' ? "CompositeQuestion" : score.questionNo;
        lables.map((label) => {
            let valobj = score.data.find((data) => {
                return label.code == data.code;
            })
            if (valobj) {
                innerArray.push(valobj.value);
            }
        })
        outputScoreArray.push(
            {
                displayName: score.displayName,
                questionNo: questionNo, //questionNo is blank for Composite levels.
                values: innerArray
            }
        )
    })

    /*for (let i = 0; i < inputScoreArray.length; i++) {
        let smsScore = inputScoreArray[i];
        innerArray = [];
        let questionNo = smsScore.questionNo == '' ? "CompositeQuestion" : smsScore.questionNo;
        for (let a = 0; a < lables.length; a++) {
            let labelCode = lables[a].code;
            for (let smsi = 0; smsi < smsScore.data.length; smsi++) {
                let valSMS = smsScore.data[smsi];
                if (valSMS.code == labelCode) {
                    innerArray.push(valSMS.value);
                    break;
                }
            }
        }
        outputScoreArray.push(
            {
                displayName: smsScore.displayName,
                questionNo: questionNo, //questionNo is blank for Composite levels.
                values: innerArray
            }
        )
    }*/
    return outputScoreArray;
}

function AddSigTestingArrow(trend) {
    let result = "";
    switch (trend) {
        case "4": {
            result = '<i class=material-icons style=\\"color: green;\\">arrow_drop_up</i>';
            break;
        }
        case "3": {
            result = '<i class=material-icons style=\\"color: red;\\">arrow_drop_down</i>';
            break;
        }
        default: {
            result = "";
        }
    }
    return result;
}

function getScoreArrayForTable(lables, inputScoreArray) {

   // console.log(JSON.stringify(inputScoreArray));

    let tableDataSMSScoreArray = "";
    inputScoreArray.map((score) => {
        let isBenchmark = false;
        let questionNo = score.questionNo == '' ? "CompositeQuestion" : score.questionNo;

        if (score.displayName == "Benchmark") {
            isBenchmark = true;
            tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"<strong>' + score.displayName + '</strong>",';
            //tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"' + score.displayName + '",';
        }
        else {
            tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"' + score.displayName + '",';
        }

        tableDataSMSScoreArray = tableDataSMSScoreArray + '"questionNo":"' + questionNo + '",';

        lables.map((label) => {
            let valobj = score.data.find((data) => {
                return label.code == data.code;
            })

            if (valobj) {
                let arrowBenchmark = AddSigTestingArrow(valobj.trend);

                if (isBenchmark) {
                    if (questionNo == 'CompositeQuestion') { // do not display ValidN for composite levels.
                        tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '"'
                            + ':' + '"' + arrowBenchmark + '<strong>' + valobj.value + '</strong>",';
                           // + ':' + '"' + arrowBenchmark + '' + valobj.value + '",';
                          //  + ':' + '"' + '' + valobj.value + '",';

                        //tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_trend' +'"'
                        //    + ':' + '"' + '' + valobj.trend + '",';
                    }
                    else {
                        tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '"'
                            + ':' + '"' + arrowBenchmark + '<strong>' + valobj.value + '<br/>' + valobj.validN + '</strong>",';
                            //+ ':' + '"' + arrowBenchmark + '' + valobj.value + '<br/>' + valobj.ValidN + '",';
                           // + ':' + '"' + '' + valobj.value + '",';

                       // tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_ValidN' + '"'
                          //  + ':' + '"' + '' + valobj.validN + '",';

                       // tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_trend' + '"'
                         //   + ':' + '"' + '' + valobj.trend + '",';
                    }
                }
                else {
                    if (questionNo == 'CompositeQuestion') {
                       // let arrow = AddSigTestingArrow(valobj.trend);
                        tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '"'
                            + ':' + '"' + arrowBenchmark + valobj.value + '",';
                        //    + ':' + '"' + valobj.value + '",';


                        //tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_trend' + '"'
                        //    + ':' + '"' + '' + valobj.trend + '",';
                    }
                    else {
                        tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '"'
                            + ':' + '"' + arrowBenchmark + valobj.value + '<br/>' + valobj.validN + '",';
                          //  + ':' + '"' + valobj.value + '",';

                        //tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_ValidN' + '"'
                        //    + ':' + '"' + '' + valobj.validN + '",';

                        //tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valobj.code] + '_trend' + '"'
                        //    + ':' + '"' + '' + valobj.trend + '",';
                    }
                }
            }
        });
        let lastcomma = tableDataSMSScoreArray.lastIndexOf(',');
        tableDataSMSScoreArray = tableDataSMSScoreArray.substring(0, lastcomma);
        tableDataSMSScoreArray = tableDataSMSScoreArray + '},';
    });

    let lastcommaTableData = tableDataSMSScoreArray.lastIndexOf(',');
    tableDataSMSScoreArray = tableDataSMSScoreArray.substring(0, lastcommaTableData);
    tableDataSMSScoreArray = JSON.parse('[' + tableDataSMSScoreArray + ']');

    //console.log(JSON.stringify(tableDataSMSScoreArray));

    /*for (let i = 0; i < inputScoreArray.length; i++) {
        let smsScore = inputScoreArray[i];
        let isBenchmark = false;
        let questionNo = smsScore.questionNo == '' ? "CompositeQuestion" : smsScore.questionNo;
        if (smsScore.displayName == "Benchmark") {
            isBenchmark = true;
            tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"<strong>' + smsScore.displayName + '</strong>",';
        }
        else {
            tableDataSMSScoreArray = tableDataSMSScoreArray + '{"displayName":"' + smsScore.displayName + '",';
        }
        tableDataSMSScoreArray = tableDataSMSScoreArray + '"questionNo":"' + questionNo + '",';
        for (let a = 0; a < lables.length; a++) {
            let labelCode = lables[a].code;
            for (let smsi = 0; smsi < smsScore.data.length; smsi++) {
                let valSMS = smsScore.data[smsi];
                if (valSMS.code == labelCode) {
                    if (isBenchmark) {
                        if (questionNo == 'CompositeQuestion') { // do not display ValidN for composite levels.
                            let arrowBenchmark = AddSigTestingArrow(valSMS.trend);
                            tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valSMS.code] + '"'
                                + ':' + '"' + arrowBenchmark + '<strong>' + valSMS.Value + '</strong>",';
                        }
                        else {
                            tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valSMS.code] + '"'
                                + ':' + '"' + arrowBenchmark + '<strong>' + valSMS.Value + '<br/>' + valSMS.ValidN + '</strong>",';
                        }
                    }
                    else {
                        if (questionNo == 'CompositeQuestion') {
                            let arrow = AddSigTestingArrow(valSMS.trend);
                            tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valSMS.code] + '"'
                                + ':' + '"' + arrow + valSMS.Value + '",';
                        }
                        else {
                            tableDataSMSScoreArray = tableDataSMSScoreArray + '"' + [valSMS.code] + '"'
                                + ':' + '"' + arrow + valSMS.Value + '<br/>' + valSMS.ValidN + '",';
                        }
                    }
                    break;
                }
            }
        }
        let lastcomma = tableDataSMSScoreArray.lastIndexOf(',');
        tableDataSMSScoreArray = tableDataSMSScoreArray.substring(0, lastcomma);
        tableDataSMSScoreArray = tableDataSMSScoreArray + '},';
    }
    let lastcommaTableData = tableDataSMSScoreArray.lastIndexOf(',');
    tableDataSMSScoreArray = tableDataSMSScoreArray.substring(0, lastcommaTableData);
    tableDataSMSScoreArray = JSON.parse('[' + tableDataSMSScoreArray + ']');*/
    return tableDataSMSScoreArray;
}


function SetTableDataSets(tableData, QuestionNo) {
    let tableDataSet = [];
    for (let i = 0; i < tableData.length; i++) {
        let tblData = tableData[i];
        if (tblData.questionNo != QuestionNo) continue;
        tableDataSet.push(tblData);
    }
    return tableDataSet;
}

function SetChartDataSets(chartData, QuestionNo) {
    let chartDataSets = [];
    let colors = ['#203E57', '#0072AD', '#53c68c', '#ffb3ff', '#005582', '#4dc1ff',
        '#00e673', '#8585e0', '#8585e0'];
    let bobColor = '#8C9396';
    let colorCounter = 0;

    for (let n = 0; n < chartData.length; n++) {

        if (QuestionNo != chartData[n].questionNo)
            continue;

        let srs = chartData[n];
        let chartType = 'horizontalBar';
        let anchor = 'end';
        let datalabelcolor = '#ffffff';
        let align = 'start';
        let barColor = colors[colorCounter];

        if (srs.displayName == 'Benchmark') {
            anchor = 'end',
                align = 'start',
                //datalabelcolor = '#000000',
                barColor = bobColor
        }
        else {
            colorCounter++;
        }
        let datalabels = {
            color: datalabelcolor,
            anchor: anchor,
            align: align,
            //color: '#005582',
            //offset: 15,
            //rotation: 180,
            //display: 'auto',
            formatter: function (value) {
                if (value == 0) return "";
                else return value;
                //else return value + '%';
            },
            font: {
                weight: 'bold',
                size: 10,
            }
        }
        let multiplyfactor = 0;
        if (srs.values.length > 4) {
            multiplyfactor = 1.4;
        }
        else {
            multiplyfactor = 1.9;
        }
        let barThickness = Math.round(multiplyfactor * (window.innerHeight) / 100);
        let chartdb = {
            label: srs.displayName,
            data: srs.values,
            //legend: {
            //    display: false,
            //    usePointStyle: true
            //},
            type: chartType,
            showLine: false,
            backgroundColor: barColor,
            fill: 'false',
            //borderColor: '#005582',
            borderWidth: '1',
            datalabels: datalabels,
            barPercentage: 1,
            barThickness: barThickness,
        }
        chartDataSets.push(chartdb);
    }
    return chartDataSets;
}

// mutations
const mutations = {
    resetCompositeQuestionText(state) {
        state.QuestionList = [];
        state.chartDataApi = Array;
        state.tableDataApi = Array;
        state.chartData = Array;
        state.tableData = [];
        state.headerData = [];
        state.modelQuestionRadios = 'CompositeQuestion';
        state.currentQuestion = ''
    },
    setCompositeQuestionText(state, { apiData }) {
        state.QuestionList = apiData;
    },
    setChartAndTableData(state, { apiData, scoreView }) {
        //console.log(JSON.stringify(apiData));
       // debugger;
        let chartData = apiData.chartData;
        let tableData = apiData.tableData;
        //Get table headers and chart x-axis labels.
        let resultHeaders = getTableHeadersAndChartLabels(chartData.lables);
        let tableHeaders = resultHeaders.tableHeaders;
        let chartCategories = resultHeaders.chartCategories;

        //Get Scaled Mean Score data for chart and data table.
        let smsScoreArray = getScoreArrayForChart(chartData.lables, chartData.scaledMeanScore);
        let tableDataSMSScoreArray = getScoreArrayForTable(chartData.lables, tableData.scaledMeanScore);
        //Get Summary Rate Score data for chart and data table.
        let srScoreArray = getScoreArrayForChart(chartData.lables, chartData.summaryRate);
        let tableDataSRScoreArray = getScoreArrayForTable(chartData.lables, tableData.summaryRate);
        //Get Top Box Rate Score data for chart and data table.
        let tpScoreArray = getScoreArrayForChart(chartData.lables, chartData.topBoxRate);
        let tableDataTPScoreArray = getScoreArrayForTable(chartData.lables, tableData.topBoxRate);

        //state.currentQuestion = state.QuestionList.compositeText + ' - ' + 'Composite';
        if (state.QuestionList.questionData.length > 1) {
            state.modelQuestionRadios = 'CompositeQuestion';
            state.currentQuestion = state.QuestionList.compositeText + ' - ' + 'Composite';
        }
        else {
            let questionNo = state.QuestionList.questionData[0].questionNum;
            let shortQuestionText = state.QuestionList.questionData[0].shortQuestionText;
            state.modelQuestionRadios = questionNo;
            state.currentQuestion = state.QuestionList.compositeText + ' - ' + questionNo + ' ' + shortQuestionText;
        }

        let chartDataSets = [];
        let dataForTable = [];
        if (scoreView == 'scaledMeanScore') {
            chartDataSets = SetChartDataSets(smsScoreArray, state.modelQuestionRadios);
            dataForTable = SetTableDataSets(tableDataSMSScoreArray, state.modelQuestionRadios);
        }
        else if (scoreView == 'summaryRateScore') {
            chartDataSets = SetChartDataSets(srScoreArray, state.modelQuestionRadios);
            dataForTable = SetTableDataSets(tableDataSRScoreArray, state.modelQuestionRadios);
            // dataForTable = tableDataSRScoreArray;
        }
        else if (scoreView == 'topBoxScore') {
            chartDataSets = SetChartDataSets(tpScoreArray, state.modelQuestionRadios);
            dataForTable = SetTableDataSets(tableDataTPScoreArray, state.modelQuestionRadios);
            // dataForTable = tableDataTPScoreArray;
        }

        let updatedChartData = {
            datasets: chartDataSets,
            labels: chartCategories
        };

        state.chartDataApi = {
            labels: chartCategories,
            smsScoreArray: smsScoreArray,
            srScoreArray: srScoreArray,
            tpScoreArray: tpScoreArray
        };

        state.tableDataApi = {
            headers: tableHeaders,
            tableDataSMSScoreArray: tableDataSMSScoreArray,
            tableDataSRScoreArray: tableDataSRScoreArray,
            tableDataTPScoreArray: tableDataTPScoreArray,
        };
        //Set Chart Data
        //console.log(JSON.stringify(state.chartDataApi));
        state.chartData = updatedChartData
        //Set Table Headers
        state.headerData = tableHeaders;
        //Set Table Data
        state.tableData = dataForTable;
    },

    setChartDataAsPerScoreView(state, { scoreView }) {
        if (state.QuestionList.length == 0) return;

        let chartData = state.chartDataApi;
        let tableData = state.tableDataApi;

        let smsScoreArray = chartData.smsScoreArray;
        let srScoreArray = chartData.srScoreArray;
        let tpScoreArray = chartData.tpScoreArray;

        let chartDataSets = [];
        let dataForTable = [];
        if (scoreView == 'scaledMeanScore') {
            chartDataSets = SetChartDataSets(smsScoreArray, state.modelQuestionRadios);
            dataForTable = SetTableDataSets(tableData.tableDataSMSScoreArray, state.modelQuestionRadios);
        }
        else if (scoreView == 'summaryRateScore') {
            chartDataSets = SetChartDataSets(srScoreArray, state.modelQuestionRadios);
            dataForTable = SetTableDataSets(tableData.tableDataSRScoreArray, state.modelQuestionRadios);
        }
        else if (scoreView == 'topBoxScore') {
            chartDataSets = SetChartDataSets(tpScoreArray, state.modelQuestionRadios);
            dataForTable = SetTableDataSets(tableData.tableDataTPScoreArray, state.modelQuestionRadios);
        }
        let updatedChartData = {
            datasets: chartDataSets,
            labels: chartData.labels
        };
        //Set Chart Data
        state.chartData = updatedChartData
        //Set Table Data
        state.tableData = dataForTable;
    },

    setChartDataAsPerQuestion(state, { QuestionNo, scoreView }) {
        if (QuestionNo == 'CompositeQuestion') {
            state.currentQuestion = state.QuestionList.compositeText + ' - ' + 'Composite';
        }
        else {
            let questionObj = state.QuestionList.questionData.filter((data) => {
                return data.questionNum == QuestionNo;
            });
            if (questionObj.length > 0) {
                state.currentQuestion = state.QuestionList.compositeText + ' - ' + QuestionNo + ' ' + questionObj[0].shortQuestionText;
            }
            else {
                state.currentQuestion = state.QuestionList.compositeText + ' ' + QuestionNo;
            }
        }

        let chartData = state.chartDataApi;
        let tableData = state.tableDataApi;

        let smsScoreArray = chartData.smsScoreArray;
        let srScoreArray = chartData.srScoreArray;
        let tpScoreArray = chartData.tpScoreArray;

        let chartDataSets = [];
        let dataForTable = [];
        if (scoreView == 'scaledMeanScore') {
            chartDataSets = SetChartDataSets(smsScoreArray, QuestionNo);
            dataForTable = SetTableDataSets(tableData.tableDataSMSScoreArray, QuestionNo);
        }
        else if (scoreView == 'summaryRateScore') {
            chartDataSets = SetChartDataSets(srScoreArray, QuestionNo);
            dataForTable = SetTableDataSets(tableData.tableDataSRScoreArray, QuestionNo);
        }
        else if (scoreView == 'topBoxScore') {
            chartDataSets = SetChartDataSets(tpScoreArray, QuestionNo);
            dataForTable = SetTableDataSets(tableData.tableDataTPScoreArray, QuestionNo);
        }
        let updatedChartData = {
            datasets: chartDataSets,
            labels: chartData.labels
        };
        //Set Chart Data
        state.chartData = updatedChartData
        //Set Table Data
        state.tableData = dataForTable;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}